// import React, {  useEffect,useState } from 'react'
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Assets/Css/home.css'

// import { FaWhatsapp } from "react-icons/fa";
// import { FaAnglesUp } from "react-icons/fa6";


// import ScrollToTop from './Webpages/ScrollToTop'

// import WebHeader from './Components/WebHeader'
// import WebFooter from './Components/WebFooter'
// import HomePage from './Webpages/HomePage'
// import About from './Webpages/About';
// import Contact from './Webpages/Contact';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Parteners from './Webpages/Parteners';
// import leaf from './Assets/Image/leaf.jpg'
// import DonationPayments from './Webpages/DonationPayments';



// // Pages
// const App = () => {

//   useEffect(() => {
//   AOS.init({
//     duration: 800,
//     once: true, // Animate only once
//   });
// }, []);

//   const [showScroll, setShowScroll] = useState(false);

//   useEffect(() => {
//     const checkScroll = () => {
//       if (window.scrollY > window.innerHeight / 2) {
//         setShowScroll(true);
//       } else {
//         setShowScroll(false);
//       }
//     };

//     window.addEventListener("scroll", checkScroll);
//     return () => window.removeEventListener("scroll", checkScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

 

//   return (
//     <BrowserRouter>
      
//         <WebHeader/>
//         <div>
//           <ScrollToTop/>
//         <Routes>
//           <Route path="*" name="HomePage" element={<HomePage />} />
//           <Route path="/" name="HomePage" element={<HomePage/>} />
//           <Route path="/aboutus" name="About" element={<About/>} />
//           <Route path="/partners" name="Partners" element={<Parteners/>} />
//           <Route path="/contact" name="Contact" element={<Contact/>} />
//           <Route path="/donationpayment" name="Donation Payment" element={<DonationPayments/>} />
//         </Routes>
       
//            {/* <a
//       href="https://wa.me/12145360246" 
//         className="whatsapp-icon"
//       target="_blank"
//       rel="noopener noreferrer"
//       title="Chat with us!"
//     >
//           <FaWhatsapp />
//         </a> */}
        

// {showScroll && (
//   <button className="scroll-to-top show"  onClick={scrollToTop}>
//     <img   src={leaf}  alt="Scroll to top"
//     className="scrollimg" 
    
//      />
//   </button>
// )}


//         </div>
//      <WebFooter/>
      
//     </BrowserRouter>
//   )
// }

// export default App









import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css';
import ScrollToTop from './Webpages/ScrollToTop';
import WebHeader from './Components/WebHeader';
import WebFooter from './Components/WebFooter';
import ProtectedRoute from './Components/ProtectedRoute';
import HomePage from './Webpages/HomePage';
import About from './Webpages/About';
import Contact from './Webpages/Contact';
import Parteners from './Webpages/Parteners';
import leaf from './Assets/Image/leaf.jpg';
import DonationPayments from './Webpages/DonationPayments';
import AOS from 'aos';
import 'aos/dist/aos.css';
import StripeDonationForm from './Webpages/StripeDonationForm';
import OrderConfirmationPage from './Webpages/ConfirmationPage';
import AdminLogin from './Webpages/AdminLogin';
import Donationdetails from './Webpages/Donationdetails';
import Dashboard from './Webpages/Dashboard';
import RedirectIfAuth from './Components/RedirectIfAuth'; 

const AppContent = () => {
  const location = useLocation();
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  useEffect(() => {
    const checkScroll = () => {
      setShowScroll(window.scrollY > window.innerHeight / 2);
    };
    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Add paths where header/footer should be hidden
  const hideHeaderFooterRoutes = ['/donationpayment'];
  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);
 
  const hidestripeformHeaderFooterRoutes = ['/stripedonationform'];
   const shouldstripeformHideHeaderFooter = hidestripeformHeaderFooterRoutes.includes(location.pathname);

   const hideconfirmation = ['/confirmation'];
   const shouldconfirmation = hideconfirmation.includes(location.pathname);
   
   const hideadmin = ['/admin'];
   const shouldadmin = hideadmin.includes(location.pathname);

   const hidedonationdtl= ['/donationdetails'];
   const shoulddonationdtl = hidedonationdtl.includes(location.pathname);

    const hidedashboard= ['/dashboard'];
   const shoulddashboard = hidedashboard.includes(location.pathname);

 
   return (
    <>
     {!shouldHideHeaderFooter && !shouldstripeformHideHeaderFooter && 
     !shouldconfirmation && !shouldadmin && !shoulddonationdtl && !shoulddashboard &&
     <WebHeader />}
<ScrollToTop />
<Routes>
  <Route path="*" element={<HomePage />} />
  <Route path="/" element={<HomePage />} />
  <Route path="/aboutus" element={<About />} />
  <Route path="/partners" element={<Parteners />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/donationpayment" element={<DonationPayments />} />
  <Route path="/stripedonationform" element={<StripeDonationForm />} />
   <Route path="/confirmation" element={<OrderConfirmationPage />} />


  
 <Route
        path="/admin"
        element={
          <RedirectIfAuth>
            <AdminLogin />
          </RedirectIfAuth>
        }
      />

      {/* Protected Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

   <Route
  path="/donationdetails"
  element={
    <ProtectedRoute>
      <Donationdetails />
    </ProtectedRoute>
  }
/>

</Routes>

{showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
    <img src={leaf} alt="Scroll to top" className="scrollimg" />
  </button>
)}

{!shouldHideHeaderFooter && !shouldstripeformHideHeaderFooter && 
!shouldconfirmation && !shouldadmin && !shoulddonationdtl && !shoulddashboard &&
 <WebFooter />}

    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;
